import { useState, useCallback } from 'react';

interface DialogState {
  isOpen: boolean;
  question: string;
  actionType: string;
  resolve: ((value: boolean) => void) | null;
}

const initialState: DialogState = {
  isOpen: false,
  question: '',
  actionType: '',
  resolve: null,
};

export const useDialog = () => {
  const [dialogState, setDialogState] = useState<DialogState>(initialState);

  const confirm = useCallback((question: string, actionType: string = 'default_action'): Promise<boolean> => {
    console.log('🔄 useDialog.confirm called with:', { question, actionType });
    return new Promise((resolve) => {
      console.log('📝 Setting dialog state to open...');
      setDialogState({
        isOpen: true,
        question,
        actionType,
        resolve,
      });
    });
  }, []);

  const handleClose = useCallback(() => {
    console.log('❌ useDialog.handleClose called, resolving with false');
    if (dialogState.resolve) {
      dialogState.resolve(false);
    }
    console.log('🚪 Resetting dialog state...');
    setDialogState(initialState);
  }, [dialogState]);

  const handleConfirm = useCallback(() => {
    console.log('✅ useDialog.handleConfirm called, resolving with true');
    if (dialogState.resolve) {
      dialogState.resolve(true);
    }
    console.log('🚪 Resetting dialog state...');
    setDialogState(initialState);
  }, [dialogState]);

  return {
    confirm,
    dialogState,
    handleClose,
    handleConfirm,
  };
};

export default useDialog; 